'use client';

import StrapiErrorPage from '@/components/StrapiErrorPage';
import { ERROR_CONFIG } from '@/config/error-config';

/**
 * Next.js Error Boundary
 * 
 * Automatically catches errors thrown during server-side rendering
 * or data fetching in Server Components. Uses the StrapiErrorPage
 * component with glass morphism design and auto-retry functionality.
 */
export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <StrapiErrorPage 
      error={error} 
      reset={reset} 
      countdown={ERROR_CONFIG.RETRY_COUNTDOWN_SECONDS}
      maxRetries={ERROR_CONFIG.MAX_RETRY_ATTEMPTS}
    />
  );
}
